import { create } from 'zustand'

export interface PaymentDrawerRequest {
  leaseId?: string
  amount?: number
}

interface PaymentDrawerState {
  /** Non-null while the desktop record / pay drawer is open; `key` remounts it per opening. */
  request: (PaymentDrawerRequest & { key: number }) | null
  show: (request: PaymentDrawerRequest) => void
  close: () => void
}

export const usePaymentDrawerStore = create<PaymentDrawerState>((set) => ({
  request: null,
  show: (request) => set({ request: { ...request, key: Date.now() } }),
  close: () => set({ request: null }),
}))
